import { createSelector } from 'reselect';
import { RootState } from 'store';
import { AddonService } from 'types/AddonService';
import { MarketplaceServiceCategory } from 'types/Marketplace';

export const getAddonServicesState = (state: RootState) => state.addonServices;

export const getActiveAddonServices = createSelector(
    (state: RootState) => state.addonServices,
    state =>
        state.addonServices
            .filter(addon => addon.active)
            .sort((a, b) => a.name.localeCompare(b.name))
);

// An add-on with no business areas is global and shows in every category.
export const filterAddonsByBusinessAreas = (
    addons: Array<AddonService>,
    businessAreas: Array<MarketplaceServiceCategory>
): Array<AddonService> =>
    addons.filter(
        addon =>
            addon.businessAreas.length === 0 ||
            addon.businessAreas.some(area =>
                businessAreas.includes(area as MarketplaceServiceCategory)
            )
    );
